import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="py-24 bg-light-alt" data-id="element-67">
      <div className="container mx-auto px-6 md:px-12" data-id="element-68">
        <div className="bg-white rounded-sm shadow-xl overflow-hidden" data-id="element-69">
          <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-70">
            {/* Contact Info */}
            <div className="bg-primary text-white p-12 lg:p-16 relative overflow-hidden" data-id="element-71">
              <div className="absolute top-0 right-0 w-64 h-64 bg-accent/10 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2" data-id="element-72"></div>
              <div className="absolute bottom-0 left-0 w-64 h-64 bg-accent/10 rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2" data-id="element-73"></div>

              <div className="relative z-10" data-id="element-74">
                <h3 className="text-3xl md:text-4xl font-serif font-bold mb-4" data-id="element-75">
                  Start Your Project
                </h3>
                <p className="text-gray-300 mb-12 text-lg" data-id="element-76">
                  Contact us today for a free initial consultation. Our team of
                  experts is ready to bring your vision to life.
                </p>

                <div className="space-y-8" data-id="element-77">
                  <div className="flex items-start gap-4" data-id="element-78">
                    <div className="w-12 h-12 bg-primary-light rounded-sm flex items-center justify-center shrink-0 text-accent" data-id="element-79">
                      <Phone size={24} data-id="element-80" />
                    </div>
                    <div data-id="element-81">
                      <h4 className="text-sm text-gray-400 uppercase tracking-wider mb-1" data-id="element-82">
                        Phone
                      </h4>
                      <p className="text-xl font-medium" data-id="element-83">(908) 613 2086</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4" data-id="element-84">
                    <div className="w-12 h-12 bg-primary-light rounded-sm flex items-center justify-center shrink-0 text-accent" data-id="element-85">
                      <Mail size={24} data-id="element-86" />
                    </div>
                    <div data-id="element-87">
                      <h4 className="text-sm text-gray-400 uppercase tracking-wider mb-1" data-id="element-88">
                        Email
                      </h4>
                      <p className="text-lg font-medium" data-id="element-89">info@renovapro.com</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4" data-id="element-90">
                    <div className="w-12 h-12 bg-primary-light rounded-sm flex items-center justify-center shrink-0 text-accent" data-id="element-91">
                      <MapPin size={24} data-id="element-92" />
                    </div>
                    <div data-id="element-93">
                      <h4 className="text-sm text-gray-400 uppercase tracking-wider mb-1" data-id="element-94">
                        Location
                      </h4>
                      <p className="text-lg font-medium" data-id="element-95">
                        2186 Balmoral Ave Union NJ 07083
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4" data-id="element-96">
                    <div className="w-12 h-12 bg-primary-light rounded-sm flex items-center justify-center shrink-0 text-accent" data-id="element-97">
                      <Clock size={24} data-id="element-98" />
                    </div>
                    <div data-id="element-99">
                      <h4 className="text-sm text-gray-400 uppercase tracking-wider mb-1" data-id="element-100">
                        Hours
                      </h4>
                      <p className="text-lg font-medium" data-id="element-101">
                        Mon - Fri: 8:00 AM - 6:00 PM
                        <br data-id="element-102" />
                        Sat: 9:00 AM - 2:00 PM
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="p-12 lg:p-16" data-id="element-103">
              <h3 className="text-2xl font-serif font-bold text-primary mb-8" data-id="element-104">
                Send Us a Message
              </h3>

              <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-105">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-106">
                  <div data-id="element-107">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-108">
                      Full Name
                    </label>
                    <input type="text" className="w-full px-4 py-3 bg-light-alt border border-gray-200 rounded-sm focus:outline-none focus:border-accent focus:ring-1 focus:ring-accent transition-colors" placeholder="John Smith" data-id="element-109" />
                  </div>
                  <div data-id="element-110">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-111">
                      Phone
                    </label>
                    <input type="tel" className="w-full px-4 py-3 bg-light-alt border border-gray-200 rounded-sm focus:outline-none focus:border-accent focus:ring-1 focus:ring-accent transition-colors" placeholder="(555) 000-0000" data-id="element-112" />
                  </div>
                </div>

                <div data-id="element-113">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-114">
                    Email Address
                  </label>
                  <input type="email" className="w-full px-4 py-3 bg-light-alt border border-gray-200 rounded-sm focus:outline-none focus:border-accent focus:ring-1 focus:ring-accent transition-colors" placeholder="john@example.com" data-id="element-115" />
                </div>

                <div data-id="element-116">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-117">
                    Project Type
                  </label>
                  <select className="w-full px-4 py-3 bg-light-alt border border-gray-200 rounded-sm focus:outline-none focus:border-accent focus:ring-1 focus:ring-accent transition-colors text-gray-700" data-id="element-118">
                    <option value="" data-id="element-119">Select an option</option>
                    <option value="kitchen" data-id="element-120">Kitchen Remodel</option>
                    <option value="bathroom" data-id="element-121">Bathroom Remodel</option>
                    <option value="addition" data-id="element-122">Home Addition</option>
                    <option value="full" data-id="element-123">Full Remodel</option>
                    <option value="other" data-id="element-124">Other</option>
                  </select>
                </div>

                <div data-id="element-125">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-126">
                    Project Details
                  </label>
                  <textarea rows={4} className="w-full px-4 py-3 bg-light-alt border border-gray-200 rounded-sm focus:outline-none focus:border-accent focus:ring-1 focus:ring-accent transition-colors resize-none" placeholder="Tell us a little about what you have in mind..." data-id="element-127"></textarea>
                </div>

                <button type="submit" className="w-full bg-accent hover:bg-accent-hover text-white font-medium py-4 rounded-sm transition-colors text-lg" data-id="element-128">
                  Request a Quote
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>;
}